/**
 * Envision Customizations
 * assets/article.js
 *
 * Custom JavaScript
 */


/**
 * Featured Spices - Display products from article metafields after .rk_header
 */
(function() {
  async function fetchFeaturedSpicesSection() {
    try {
      // Use a dedicated layout none template that has full article context
      const templateUrl = `${window.location.pathname}?view=featured-spices`;
      
      const response = await fetch(templateUrl);
      const html = await response.text();
      return html;
    } catch (error) {
      console.error('Error fetching featured spices section:', error);
      return null;
    }
  }

  function insertFeaturedSpices(rkHeader, sectionHTML) {
    if (!sectionHTML || !sectionHTML.trim()) return;
    
    // Create a container for the section and parse the HTML
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = sectionHTML.trim();
    
    // Get the first actual element (skip text nodes)
    const sectionElement = tempContainer.firstElementChild;
    if (!sectionElement) {
      return;
    }
    
    // Insert after the .rk_header element
    rkHeader.parentNode.insertBefore(sectionElement, rkHeader.nextSibling);
  }

  async function initFeaturedSpices() {
    // Check if article has recipe products
    const recipeProducts = window.articleRecipeProducts;
    if (!recipeProducts || !Array.isArray(recipeProducts) || recipeProducts.length === 0) {
      return; // No products to display
    }

    // Wait for .rk_header to be available
    try {
      const rkHeader = await waitForElm('.rk_header');
      const sectionHTML = await fetchFeaturedSpicesSection();
      if (sectionHTML) {
        insertFeaturedSpices(rkHeader, sectionHTML);
      }
    } catch (error) {
      console.error('Error initializing featured spices:', error);
    }
  }

  /**
   * RecipeKit images - remove aspect_ratio param from image src
   */
  function cleanupRecipeKitImagesAspectRatio() {
    try {
      const images = document.querySelectorAll('#rk_parent .rk_modern .rk_container .rk_image img');
      images.forEach((img) => {
        const src = img.getAttribute('src');
        if (!src) return;
        try {
          const url = new URL(src, window.location.href);
          if (url.searchParams.has('aspect_ratio')) {
            url.searchParams.delete('aspect_ratio');
            img.setAttribute('src', url.toString());
          }
        } catch (e) {
          // Fallback: simple string replace if URL parsing fails
          const withoutParam = src.replace(/([?&])aspect_ratio=[^&]*&?/, (match, sep) => {
            // Remove trailing separators cleanly
            const remainder = src.slice(src.indexOf(match) + match.length);
            if (sep === '?' && !remainder.includes('&')) {
              return '';
            }
            return sep;
          }).replace(/[?&]$/, '');
          if (withoutParam !== src) {
            img.setAttribute('src', withoutParam);
          }
        }
      });
    } catch (error) {
      console.error('Error cleaning RecipeKit image aspect_ratio params:', error);
    }
  }

  function initRecipeKitImageSrcCleanup() {
    cleanupRecipeKitImagesAspectRatio();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initFeaturedSpices();
      initRecipeKitImageSrcCleanup();
    });
  } else {
    initFeaturedSpices();
    initRecipeKitImageSrcCleanup();
  }
})();